/**
 * Abstract base class for skeleton post-processors.
 *
 * Post-processors are applied after the base animation/bind pose layer,
 * allowing procedural modifications like IK, spring physics, or manual overrides.
 *
 * @public
 */ class SkeletonModifier {
    /** Whether this processor is enabled */ _enabled;
    constructor(){
        this._enabled = true;
    }
    /**
   * Get the blend weight [0-1]
   */ get weight() {
        return this._getWeight();
    }
    set weight(value) {
        this._setWeight(value);
    }
    /**
   * Get whether this processor is enabled
   */ get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        this._enabled = value;
    }
}

export { SkeletonModifier };
//# sourceMappingURL=skeleton_modifier.js.map
